// import { Flickity } from 'flickity'
import Flickity from 'flickity'

export default class CarouselSkeleton {
  constructor(el) {
    this.el = el
    this.setVariables()
    this.init()
  }

  setVariables() {
    this.prevNextButtons = this.el.dataset.showprevnext ? this.el.dataset.showprevnext : true;
    this.next = this.el.querySelector('[data-next]')
    this.prev = this.el.querySelector('[data-prev]')
    this.currentIndex = 0
    this.pagination = this.el.querySelector('[data-pagination]')
    this.hiddenCls = 'hidden';
    this.carousel = this.el.querySelector('[data-carousel]');
    this.slides = this.el.querySelectorAll('.carousel-cell');
    this.flickity = null
    this.flickitySettings = this.el.dataset.flickitySettings ?? null
    this.arrowDisabled = ['opacity-0', 'hidden'] // classes applied if it is first or last
  }

  init() {
    this.handleRemoveHidden()
    this.initCarousel()
  }

  handleRemoveHidden() {
    this.slides.forEach( element => {
      element.classList.remove(this.hiddenCls);
    } )
  }

  handleFocusManagement() {
    this.slides.forEach(slide => {
      const interactiveElementsInSlide = slide.querySelectorAll('a, button, input, [tabindex]');

      // Skip if there are no interactive elements in this slide
      if(interactiveElementsInSlide.length === 0) {
        return;
      }

      interactiveElementsInSlide.forEach(interactiveElement => {
        if (slide.getAttribute('aria-hidden') === 'true') {
          this.hideElement(interactiveElement)
          // interactiveElement.setAttribute('tabindex', '-1');
        } else {
          this.showElement(interactiveElement)
          // interactiveElement.removeAttribute('tabindex');
        }
      });
    });
  }

  hideElement(element) {
    element.setAttribute('tabindex', '-1')
    element.setAttribute('aria-disabled', 'true')
  }
  showElement(element) {
    element.removeAttribute('tabindex')
    element.removeAttribute('aria-disabled')
  }

  generateNavigation() {
    let buttons = this.pagination.querySelectorAll('[data-button]');
    buttons = [...buttons];

    this.pagination.addEventListener( 'click', ( event ) => {
      // filter for button clicks
      const index = buttons.indexOf( event.target );
      this.flickity.select( index );
    });
  }

  checkStatus() {
    // Enable/disable previous/next buttons
    const total = this.flickity.slides.length - 1
    const current = this.flickity.selectedIndex

    this.handleFocusManagement();

    if(current === total) {
      this.next.classList.add(...this.arrowDisabled)
      this.hideElement(this.next)
      this.next.disabled = true
    } else {
      this.next.classList.remove(...this.arrowDisabled)
      this.showElement(this.next)
      this.next.disabled = false
    }
    if(current === 0) {
      this.prev.classList.add(...this.arrowDisabled)
      this.hideElement(this.prev)
      this.prev.disabled = true
    } else {
      this.prev.classList.remove(...this.arrowDisabled)
      this.showElement(this.prev)
      this.prev.disabled = false
    }
  }

  initCarousel() {
    const defaults = {
      accessibility: true,
      adaptiveHeight: false,
      autoPlay: false,
      cellAlign: 'left',
      cellSelector: '.carousel-cell',
      contain: true,
      draggable: '>1',
      // dragThreshold: 3,
      freeScroll: false,
      // friction: 0.2,
      groupCells: '100%',
      // initialIndex: 0,
      lazyLoad: true,
      // percentPosition: true,
      prevNextButtons: false, // we're manually adding these
      pageDots: false,
      resize: true,
      // rightToLeft: false,
      setGallerySize: true,
      watchCSS: true,
      wrapAround: false,
      on: {
        change: () => this.checkStatus()
      }
    }
    const customSettings = JSON.parse(this.flickitySettings)

    const flickitySettings = {
      ...defaults,
      ...customSettings
    }


    this.flickity = new Flickity(this.carousel, flickitySettings);
    window.caroInstances.push(this.flickity)

    this.generateNavigation();
    this.checkStatus()

    // manually advance or select last slide
    if(this.next) {
      this.next.addEventListener('click', () => {
        this.flickity.next()
      })
    }
    if(this.prev) {
      this.prev.addEventListener('click', () => {
        this.flickity.previous()
      })
    }
  }
}
